<div class="range" (click)="openPickerPanel()" #pickerPanelOrigin>
  <div class="start">
    <div class="date">{{ dateVal.date }}</div>
    <div class="time" *ngIf="dateVal.time">{{ dateVal.time }}</div>
  </div>
</div>

<ng-template #pickerPanel>
  <!-- Start -->
  <div class="start">
    <div class="month">
      <div class="month-header">
        <button class="previous-button" mat-icon-button (click)="prev()" tabindex="1">
          <mat-icon [svgIcon]="'chevron_left'"></mat-icon>
        </button>
        <div class="month-label">{{ getMonthLabel(1) }}</div>
      </div>
      <mat-month-view
        [(activeDate)]="activeDates.month1"
        [dateFilter]="dateFilter()"
        (click)="$event.stopImmediatePropagation()"
        (selectedChange)="onSelectedDateChange($event)"
        #matMonthView1
      >
      </mat-month-view>
    </div>

    <mat-form-field class="treo-mat-no-subscript time start-time" *ngIf="timeRange">
      <input matInput [autocomplete]="'off'" [formControl]="timeFormControl" (blur)="updateTime($event)" tabindex="3" />
      <mat-label>Time</mat-label>
    </mat-form-field>
  </div>
</ng-template>
